import React, { useEffect } from 'react';
import { GetPatientForVizit } from '../adapters/GetPatientForVizit';

const useGetPatientsForVisit = (data, setPatientList) => {
 
  useEffect(() => {
    const inputFilter =
      data.inputFilter !== undefined ||
      data.inputFilter !== null;
    const range_input =
      data.range &&
      !Object.values(data.range).includes(undefined) &&
      !Object.values(data.range).includes('');

    if (inputFilter && range_input) {
      GetPatientForVizit(data, setPatientList);
    }
  }, [
    data.inputFilter,
    data.range?.FromDate,
    data.range?.ToDate,
    data.searchClause,
  ]);
};

export default useGetPatientsForVisit;
